<template>
  <div id="media-art-main">
    <!-- Page  -->
    <div class="indicator-container">
      <!-- Invisible indicator -->
      <Indicator
        v-if="false"
        :items="[
          { id: 1, name: 'What We Do' },
          { id: 3, name: 'Our Collections' },
          { id: 4, name: 'Our Partners' },
          { id: 5, name: 'Our Capabilities' },
          { id: 6, name: 'Add-on services' },
        ]"
        :current="currentIndicator"
        :current-section="currentSection"
        :light="isIndicatorThemeLight"
        @click="handleClickIndicator"
      />
    </div>

    <!-- Hero & About -->
    <div id="section1" ref="section1" class="container container--fluid">
      <SectionHeroAbout
        @change:scene="handleChangeHeroScene"
        @click:jumb="handleClickIndicator({ id: 3, name: 'Our Collections' })"
      />
    </div>

    <!-- About Banner -->
    <div
      id="section2"
      ref="section2"
      class="lma-container lma-container--fluid lma-container--gray"
    >
      <div class="lma-container">
        <SectionAboutBanner />
      </div>
    </div>

    <!-- Reference -->
    <div
      id="section3"
      ref="section3"
      class="lma-container lma-container--fluid lma-container--gray"
    >
      <div class="lma-container">
        <SectionReference
          v-if="filterList.length > 0 && filteredContents.length > 0"
          :current-reference-tab="currentReferenceTab"
          :current-reference-filter-id="currentReferenceFilterId"
          :filter-list="filterList"
          :filtered-contents="filteredContents"
          @change-tab="handleChangeTab"
          @click-filter="handleClickFilter"
          @click-reference-list-item="handleClickReferenceListItem"
        />
      </div>
    </div>

    <!-- Other Partners -->
    <div
      id="section4"
      ref="section4"
      class="lma-container lma-container--fluid"
    >
      <div class="lma-container">
        <SectionPartners :other-partners="otherPartners" />
      </div>
    </div>

    <!-- Contact Us -->
    <div
      id="section5"
      ref="section5"
      class="lma-container lma-container--fluid lma-container--gray"
    >
      <div class="lma-container">
        <SectionContactUs />
      </div>
    </div>

    <!-- Foot Banner -->
    <div
      id="section6"
      ref="section6"
      class="lma-container lma-container--fluid lma-container--gray"
    >
      <div class="lma-container">
        <SectionFootBanner />
      </div>
    </div>

    <!-- Detail Popup -->
    <DialogDetail
      v-if="dialogDetailOpened"
      :current-reference-list-item="currentReferenceListItem"
      :current-reference-filter-id="currentReferenceFilterId"
      @close="handeClickDetailClose"
      @preview-experience="handleClickPreviewExperience"
    />

    <!-- Preview Experiences Popup -->
    <DialogPreviewExperiences
      v-if="dialogPreviewExperienceOpened"
      :spaces="spaces"
      :current-space-item="currentSpaceItem"
      :current-reference-list-item="currentReferenceListItem"
      @close="dialogPreviewExperienceClose"
      @click-space-item="handleClickSpaceItem"
    />
  </div>
</template>

<script>
import axios from 'axios'
import Indicator from './components/Indicator.vue'
import SectionHeroAbout from './components/SectionHeroAbout.vue'
import SectionAboutBanner from './components/SectionAbout.vue'
import SectionReference from './components/SectionReference.vue'
import SectionPartners from './components/SectionPartners.vue'
import SectionContactUs from './components/SectionContactUs.vue'
import SectionFootBanner from './components/SectionFootBanner.vue'
import DialogDetail from './components/DialogDetail.vue'
import DialogPreviewExperiences from './components/DialogPreviewExperiences.vue'

export default {
  name: 'App',
  components: {
    Indicator,
    SectionHeroAbout,
    SectionAboutBanner,
    SectionReference,
    SectionPartners,
    SectionContactUs,
    SectionFootBanner,
    DialogDetail,
    DialogPreviewExperiences,
  },
  data() {
    return {
      partners: [],
      themes: [],
      contents: [],
      spaces: [],
      otherPartners: [],
      currentReferenceTab: 'partners',
      currentReferenceFilterId: 1,
      currentReferenceListItem: null,
      currentSpaceItem: null,
      dialogDetailOpened: false,
      dialogPreviewExperienceOpened: false,
      sectionIds: [
        'section1',
        'section2',
        'section3',
        'section4',
        'section5',
        'section6',
      ],
      // observer: null,
      currentHeroScene: null,
      currentSection: 'section1',
      currentIndicator: 0,
      isIndicatorThemeLight: false,
      scrollThreshold: 88, // 상단 여백
      lastScrollTop: 0, // 스크롤 방향 감지용
    }
  },
  computed: {
    filterList() {
      if (this.currentReferenceTab === 'partners') {
        return this.partners
      } else if (this.currentReferenceTab === 'themes') {
        return this.themes
      } else {
        return []
      }
    },
    filteredContents() {
      if (this.contents.length === 0) {
        return []
      } else {
        const currentFilterItem = this.filterList.find(
          (filter) => filter.id === this.currentReferenceFilterId
        )
        return this.contents.filter((content) => {
          if (
            currentFilterItem &&
            currentFilterItem.contentIds.includes(content.id)
          ) {
            return content
          }
        })
      }
    },
  },
  watch: {
    currentSection() {
      // this.handleChangeHeroScene(-1, -1)
      console.log('watch currentSection')
    },
  },
  async created() {
    try {
      document.body.style.overflow = 'hidden'
      const [
        { data: spaces },
        { data: partners },
        { data: contents },
        { data: themes },
        { data: otherPartners },
      ] = await Promise.all([
        axios.get('/theme/rbFront/img/w/mediaArtSolution/json/spaces.json'),
        axios.get('/theme/rbFront/img/w/mediaArtSolution/json/partners.json'),
        axios.get('/theme/rbFront/img/w/mediaArtSolution/json/contents.json'),
        axios.get('/theme/rbFront/img/w/mediaArtSolution/json/themes.json'),
        axios.get(
          '/theme/rbFront/img/w/mediaArtSolution/json/other-partners.json'
        ),
      ])
      this.spaces = spaces
      this.partners = partners
      this.contents = contents
      this.themes = themes
      this.otherPartners = otherPartners
      this.currentSpaceItem = this.spaces[0]
    } catch (error) {
      console.error('Error', error)
    }
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
    if (process.env.NODE_ENV === 'production') {
      document.addEventListener('contextmenu', this.disableRightClick)
      document.addEventListener('keydown', this.disableDevToolsShortcuts)
      // this.devtoolsDetectionInterval = setInterval(() => {
      //   const devtools = /./;
      //   devtools.toString = () => {
      //     this.devtoolsOpened = true;
      //   };
      //   console.log(devtools);
      //   if (this.devtoolsOpened) {
      //     alert('개발자 도구가 감지되었습니다!');
      //     window.location.href = 'about:blank';
      //   }
      // }, 1000);
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (process.env.NODE_ENV === 'production') {
      document.removeEventListener('contextmenu', this.disableRightClick)
      document.removeEventListener('keydown', this.disableDevToolsShortcuts)
      // clearInterval(this.devtoolsDetectionInterval);
    }
  },
  methods: {
    disableRightClick(event) {
      event.preventDefault()
    },
    disableDevToolsShortcuts(event) {
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && event.key === 'I')
      ) {
        event.preventDefault()
      }
    },
    handleChangeHeroScene(currentScene) {
      console.log('handleChangeHeroScene', currentScene)
      // currentScene이 있다면 현재 Scene을 변경
      if (currentScene > -1) {
        this.currentHeroScene = currentScene
      }

      // 첫번재 섹션에서 1,2,3번째 Scene일 때
      if (this.currentSection === 'section1' && this.currentHeroScene < 3) {
        this.currentIndicator = 0
        this.isIndicatorThemeLight = false
      }
      // 첫번째 섹션에서 4번째 Scene일 때
      else if (
        this.currentSection === 'section1' &&
        this.currentHeroScene === 3
      ) {
        this.currentIndicator = 0
        this.isIndicatorThemeLight = true
      } else if (this.currentSection === 'section2') {
        this.currentIndicator = 0
        this.isIndicatorThemeLight = true
      }
    },
    handleChangeTab(tab) {
      this.currentReferenceTab = tab
      this.currentReferenceFilterId = this.filterList[0].id
    },
    handleClickFilter(id) {
      this.currentReferenceFilterId = id
    },
    handleClickReferenceListItem(item) {
      this.currentReferenceListItem = item
      this.dialogDetailOpened = true
    },
    handeClickDetailClose() {
      this.dialogDetailOpened = false
      this.currentReferenceListItem = null
    },
    handleClickPreviewExperience() {
      this.dialogDetailOpened = false
      this.dialogPreviewExperienceOpened = true
    },
    dialogPreviewExperienceClose() {
      this.dialogPreviewExperienceOpened = false
      this.currentReferenceListItem = null
      this.currentSpaceItem = this.spaces[0]
    },
    handleClickSpaceItem(item) {
      this.currentSpaceItem = item
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up'
      this.lastScrollTop = scrollTop

      // 각 섹션의 위치 확인
      let newSection = this.currentSection

      for (const sectionId of this.sectionIds) {
        const element = this.$refs[sectionId]
        if (!element) continue

        const rect = element.getBoundingClientRect()
        const sectionTop = rect.top
        // const sectionBottom = rect.bottom

        // 스크롤 다운 시: 섹션 상단이 threshold 이하로 내려오면 해당 섹션으로 변경
        if (scrollDirection === 'down') {
          if (sectionTop <= this.scrollThreshold) {
            newSection = sectionId
          }
        }
        // 스크롤 업 시: 섹션 하단이 viewport를 벗어나면 이전 섹션으로 변경
        else {
          if (
            sectionTop > this.scrollThreshold &&
            sectionId === this.currentSection
          ) {
            const currentIndex = this.sectionIds.indexOf(this.currentSection)
            if (currentIndex > 0) {
              newSection = this.sectionIds[currentIndex - 1]
            }
          }
        }
      }

      if (newSection !== this.currentSection) {
        this.currentSection = newSection
        if (this.currentSection === 'section1' && this.currentHeroScene < 3) {
          this.currentIndicator = 0
          this.isIndicatorThemeLight = false
        } else if (
          (this.currentSection === 'section1' && this.currentHeroScene === 3) ||
          this.currentSection === 'section2'
        ) {
          this.currentIndicator = 0
          this.isIndicatorThemeLight = true
        } else if (this.currentSection === 'section3') {
          this.currentIndicator = 1
          this.isIndicatorThemeLight = true
        } else if (this.currentSection === 'section4') {
          this.currentIndicator = 2
          this.isIndicatorThemeLight = true
        } else if (this.currentSection === 'section5') {
          this.currentIndicator = 3
          this.isIndicatorThemeLight = true
        } else if (this.currentSection === 'section6') {
          this.currentIndicator = 4
          this.isIndicatorThemeLight = true
        }
      }
    },
    handleClickIndicator(item) {
      const sectionId = `section${item.id}`
      const element = this.$refs[sectionId]

      if (element) {
        // 스크롤할 위치 계산 (threshold 고려)
        const elementPosition =
          element.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition - this.scrollThreshold

        window.scrollTo({
          top: offsetPosition + 5,
          behavior: 'smooth',
        })
      }
    },
  },
}
</script>

<style lang="scss">
#media-art-main {
  // padding-top: 88px;
}
// ********** Layout Styles **********
.lma-container {
  font-family: 'LG EI Text';
  font-weight: 300;
  position: relative;
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
  overflow: hidden;
  &--fluid {
    max-width: 100%;
  }
  &--gray {
    background-color: #f5f5f5;
  }
}
.lma-flexbox {
  font-family: 'LG EI Text';
  font-weight: 300;
  display: flex;
  justify-content: space-between;
}

// ********** Component Styles **********
.lma-card {
  display: flex;
  flex-direction: column;
  border-radius: 40px;
  background-color: #fff;
  box-sizing: border-box;
  font-family: 'LG EI Text';
  font-weight: 300;
  &__title {
    font-family: 'LG EI Headline';
    font-size: 28px;
    font-weight: 600;
    line-height: 33.6px;
    text-align: center;
  }
}
.lma-banner {
  position: relative;
  border-radius: 30px;
  padding: 68px 100px;
  background-color: #fff;
  box-sizing: border-box;
  margin-top: 20px;
  &__text {
    display: flex;
    align-items: center;
    font-family: 'LG EI Text';
    font-size: 30px;
    font-weight: 600;
    line-height: 39px;
    text-align: left;
    height: 88px;
    color: #000;
    font-weight: 600;
  }
  &__button {
    font-family: 'LG EI Text';
    font-weight: 300;
    position: absolute;
    right: 100px;
    top: 50%;
    transform: translateY(-50%);
  }
  &--gray {
    background-color: #f6f3eb;
  }
}
.lma-headline {
  font-family: 'LG EI Headline';
  font-size: 48px;
  line-height: 57.6px;
  font-weight: 600;
  text-align: center;
  color: #000;
}
.lma-subtitle {
  font-size: 28px;
  font-weight: 600;
  line-height: 33.6px;
  text-align: center;
}
.lma-description {
  font-family: 'LG EI Text';
  font-size: 16px;
  font-weight: 400;
  line-height: 21.12px;
  text-align: center;
  color: #666;
}
.lma-bodycopy {
  font-family: 'LG EI Text';
  font-size: 24px;
  font-weight: 400;
  line-height: 31.2px;
  text-align: center;
  color: #666;
  margin-top: 16px;
}
@media screen and (max-width: 1080px) {
  .lma-banner {
    border-radius: 24px;
    padding: 32px 42px;
    margin: 20px 16px 0;
    &__text {
      height: auto;
      font-weight: 600;
      font-size: 18px;
      line-height: 21.6px;
      text-align: center;
    }
    &__button {
      position: static;
      right: auto;
      top: 0;
      transform: translateY(0);
      margin-top: 20px;
    }
  }
  .lma-card {
    flex-direction: column;
    border-radius: 24px;
  }
  .lma-headline {
    font-family: 'LG EI Headline';
    font-size: 24px;
    line-height: 28.8px;
    padding: 0 16px;
  }
  .lma-bodycopy {
    font-size: 16px;
    line-height: 21.12px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
  }
}

// Button
.lma-button {
  display: inline-flex;
  padding: 0 40px;
  height: 62px;
  border-radius: 50px;
  font-family: 'LG EI Text';
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;
  &:hover {
    font-weight: 600;
    color: #fff;
  }
  &--cta {
    background-color: #ea1917;
    color: #fff;
  }
  &--outline {
    background-color: transparent;
    border: solid 1px #ddd;
    color: #000;
    &:hover {
      color: #000;
    }
  }
  &--large {
    padding: 20px 40px;
  }
  &--outline-red {
    color: #ea1917;
    border: solid 1px #ea1917;
    &:hover {
      color: #ea1917;
    }
  }
}
@media screen and (max-width: 1080px) {
  .lma-button {
    padding: 0 20px;
    border-radius: 24px;
    font-size: 15px;
    height: 39px;

    &--large {
      padding: 20px 40px;
    }
    &--cta {
      width: 100%;
    }
    &--outline-red {
      color: #ea1917;
      border: solid 1px #ea1917;
      &:hover {
        color: #ea1917;
      }
    }
  }
}

// Dialog
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  box-sizing: border-box;
  &__container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1078px;
    max-width: 1078px;
    background-color: #fff;
    border-radius: 30px;
    padding: 48px 40px 40px;
    box-sizing: border-box;
  }
  &__title {
    font-family: 'LG EI Headline';
    font-size: 28px;
    line-height: 33.6px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 0 20px;
  }
  &__video {
    width: 100%;
    height: 300px; // temp
  }
  &__body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
  }
  &__footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  &__close {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 28px;
    right: 28px;
    background: url('/theme/rbFront/img/w/mediaArtSolution/button_close@2x.png')
      no-repeat center center;
    background-size: 16px 16px;
    border: none;
    font-size: 16px;
    color: #000;
    text-indent: -9999px;
    overflow: hidden;
  }
  @media screen and (max-width: 1080px) {
    &__container {
      width: calc(100% - 24px);
      border-radius: 24px;
      padding: 20px 12px 16px;
    }
    &__body {
      gap: 12px;
    }
    &__title {
      font-size: 22px;
      line-height: 22px;
      padding: 0 4px;
    }
    &__close {
      top: 21px;
      right: 16px;
    }
    &__footer {
      margin-top: 16px;
    }
  }
}

// Etc
.br-desktop {
  @media screen and (min-width: 1081px) {
    display: inline;
  }
  @media screen and (max-width: 1080px) {
    display: none;
  }
}
.br-mobile {
  @media screen and (min-width: 1081px) {
    display: none;
  }
  @media screen and (max-width: 1080px) {
    display: inline;
  }
}

.indicator-container {
  position: fixed;
  left: 24px;
  top: calc(50%);
  transform: translateY(-50%);
  z-index: 10;
  @media screen and (max-width: 1080px) {
    display: none;
  }
}
</style>
